export const FREIGHT_INTEGRATIONS_FETCHED = 'FREIGHT_INTEGRATIONS_FETCHED';
export const FREIGHT_INTEGRATION_ADDED = 'FREIGHT_INTEGRATION_ADDED';
export const FREIGHT_INTEGRATION_UPDATED = 'FREIGHT_INTEGRATION_UPDATED';

export const FREIGHT_INTEGRATIONS_CLEARED = 'FREIGHT_INTEGRATIONS_CLEARED';

export const FREIGHT_INTEGRATION_CREATED = 'FREIGHT_INTEGRATION_CREATED';
export const FREIGHT_INTEGRATION_FETCHED = 'FREIGHT_INTEGRATION_FETCHED';

